<script>
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	let {
		title = 'Data Driven Results',
		chartData = { indow: '20%', replacement: ['15%', '30%'] },
		children,
	} = $props();
</script>

<Section backgroundColor="white">
	<h2>{title}</h2>
	<div class="flex flex-col gap-y-10">
		<!-- heading -->
		<p
			class="flex max-w-[28ch] flex-col self-center text-[clamp(1.15rem,5vw,1.85rem)] leading-none font-bold uppercase"
		>
			average percentage saved on heating & cooling bills
		</p>
		<!-- heading ends -->
		<!-- stats starts -->
		<div
			class="grid grid-cols-[1.35fr_2fr] grid-rows-[1fr_min-content] items-end gap-x-6 gap-y-2 md:gap-x-16"
		>
			<div class="contents">
				<div
					class="bg-indow-blue flex h-2/3 items-center justify-center rounded-xs"
				>
					<p class="text-indow-white text-2xl md:text-4xl">{chartData.indow}</p>
				</div>
				<div class="grid h-[50vw] max-h-96 grid-cols-8 items-end">
					<div
						class="bg-indow-grey-dark col-[3/-1] row-span-full h-full items-center rounded-xs pt-6 md:pt-12"
					>
						<p class="text-indow-white text-2xl md:text-4xl">
							{chartData.replacement[1]}
						</p>
					</div>
					<div
						class="bg-indow-grey col-[1/7] row-span-full flex h-1/2 items-center justify-center rounded-xs"
					>
						<p class="text-indow-white text-2xl md:text-4xl">
							{chartData.replacement[0]}
						</p>
					</div>
				</div>
			</div>

			<div class="contents">
				<p
					class="!text-indow-blue self-start justify-self-center text-2xl font-bold"
				>
					INDOW
				</p>
				<p
					class="!text-indow-grey max-w-[18ch] justify-self-center text-2xl font-bold"
				>
					REPLACEMENT WINDOWS
				</p>
			</div>
		</div>
		<!-- stats ends -->
		{@render children?.()}
	</div>
</Section>
